import axios from '../utils/api/axios';

const API_BASE_URL = process.env.REACT_APP_URL;

  export const fetchArticleList = async (header: any, authorId: any, themeId: any, page: any, category_id: any) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/article/list`, {
        params: { header, author_id: authorId,theme_id: themeId, page: page, category_id: category_id}
      });
      return response.data;
    } catch (error) {
      console.error('Fetch article list request error:', error);
      throw error;
    }
  };
  
  export const fetchAutorsList = async (fio, themeId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/article/authors`, {
        params: { fio, theme_id: themeId }
      });
      return response.data;
    } catch (error) {
      console.error('Fetch authors list request error:', error);
      throw error;
    }
  };

